import Cookies from "universal-cookie";
import usePageIdentifier from "./usePageIdentifier";


const useCookies = () => {
  const { pageTitle } = usePageIdentifier();

  //console.log(pageTitle)
  const cookies = new Cookies();
  const expireDate = new Date();
  expireDate.setTime(expireDate.getTime() + 24 * 60 * 60 * 1000); //1min

  const expireIntractionDate = new Date();
  expireIntractionDate.setTime(expireIntractionDate.getTime() + 24 * 60 * 60 * 1000); // 2min

  const setContentDrawerInteractionCookie = () => {
    //console.log(`content-drawer-interaction-${pageTitle} is set`)
    cookies.set(`content-drawer-interaction-${pageTitle}`, "true", { //`content-drawer-interaction`, "true"
      expires: expireIntractionDate,
    }); //after user had intraction
  };

  const setContentDrawerTimeoutCookie = () => {
    //console.log('content-drawer-timeout set')
    cookies.set(`content-drawer-timeout-${pageTitle}`, "false", //`content-drawer-timeout`, "false"
    { expires: expireDate });
  };
  //get Cookies
  const cookiesValidation = cookies.get(`content-drawer-timeout-${pageTitle}`); // without user intraction time up //`content-drawer-timeout`
  const cookiesIntractionValidation = cookies.get(`content-drawer-interaction-${pageTitle}`); //after user had intraction // `content-drawer-interaction`
  return {
    setContentDrawerInteractionCookie,
    setContentDrawerTimeoutCookie,
    cookiesValidation,
    cookiesIntractionValidation,
  };
}
// user has 2 mins to interact with drawer (then time out and it goes away). Remember user interaction with drawer for 1 day if i recall
export default useCookies;
